import {useState} from 'react'
import {KTSVG} from '../../../helpers'
import clsx from 'clsx'

type CollapsibleTextProps = {
  text: string
  className?: string
  initialExpanded?: boolean
}
export const CollapsibleText = ({
  text,
  className,
  initialExpanded = false,
}: CollapsibleTextProps) => {
  const [expanded, setExpanded] = useState(initialExpanded)

  return (
    <div className={clsx('d-flex gap-2', className)}>
      <span
        className={clsx('transition-all duration-300 overflow-hidden', {
          'line-clamp-1': expanded,
        })}
        style={{
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: expanded ? 'unset' : 1,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {text}
      </span>
      <div
        onClick={() => setExpanded(!expanded)}
        className='text-gray-600 hover:text-black cursor-pointer'
      >
        <KTSVG path={`/media/gori/arrows/${expanded ? 'arrow_up' : 'arrow_down'}.svg`} />
      </div>
    </div>
  )
}
